<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <!-- <v-flex xs12>
          <v-card>
            <v-toolbar dense card color="grey lighten-3" flat>
              <v-toolbar-title>Date Ranges</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom" data-vv-name="form.tranDateFrom"
                    :error-messages="errors.collect('form.tranDateFrom')" v-validate="'required'" :max="systemDate" />
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo" data-vv-name="form.tranDateTo"
                    :error-messages="errors.collect('form.tranDateTo')" v-validate="'required'" :min="form.tranDateFrom" :max="systemDate" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex> -->
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Date Range
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom" data-vv-name="form.tranDateFrom"
                          :error-messages="errors.collect('form.tranDateFrom')" v-validate="'required'" :max="systemDate" />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo" data-vv-name="form.tranDateTo"
                          :error-messages="errors.collect('form.tranDateTo')" v-validate="'required'" :min="form.tranDateFrom" :max="systemDate" />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Selection Criteria
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('form.branch')" :data-vv-as="labels.branch" v-validate="'required'"
                          data-vv-name="form.branch" append-icon="mdi-magnify" @click:append="showBranchHelpList=true" @click="showBranchHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.fund" :label="labels.fund" :error-messages="errors.collect('form.fund')" :data-vv-as="labels.fund" v-validate="'required'"
                          data-vv-name="form.fund" append-icon="mdi-magnify" @click:append="showFundHelpList=true" @click="showFundHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.dept" :label="labels.dept" :error-messages="errors.collect('form.dept')" :data-vv-as="labels.dept" v-validate="'required'"
                          data-vv-name="form.dept" append-icon="mdi-magnify" @click:append="showDeptHelpList=true" @click="showDeptHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('form.polType')" :data-vv-as="labels.polType" v-validate="'required'"
                          data-vv-name="form.polType" append-icon="mdi-magnify" @click:append="showPolTypeHelpList=true" @click="showPolTypeHelpList=true" readonly/>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <!-- <v-flex xs12>
          <v-card>
            <v-toolbar dense card color="grey lighten-3" flat>
              <v-toolbar-title>Report Setting</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-select v-model="form.rptBy" :items="rptByList" :label="labels.rptBy" item-text="label" item-value="value" />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-flex xs6>
                    <v-select v-model="form.rptType" :items="rptTypeList" :label="labels.rptType" item-text="label" item-value="value" />
                  </v-flex>
                  <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
                    data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex> -->
        <v-flex xs12>
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Report Setting
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-select v-model="form.rptBy" :items="rptByList" :label="labels.rptBy" item-text="label" item-value="value" />
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-flex xs6>
                          <v-select v-model="form.rptType" :items="rptTypeList" :label="labels.rptType" item-text="label" item-value="value" />
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="showDeptHelpList" width="900px" persistent>
      <multi-dept-help-list :dept="form.dept" @close="doClose" @doAssign="doAssignDept($event)" />
    </v-dialog>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
    </v-dialog>
    <v-dialog v-model="showFundHelpList" width="900px" persistent>
      <multi-fund-help-list :fnd="form.fund" @close="doClose" @doAssign="doAssignFund($event)"/>
    </v-dialog>
    <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list :pt="form.polType" @close="doClose" @doAssign="doAssignPolType($event)" />
    </v-dialog>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [
    MessageMixin
  ],
  components: {
    MultiBranchHelpList,
    MultiPolTypeHelpList,
    MultiDeptHelpList,
    MultiFundHelpList
  },
  data() {
    return {
      menu: {},
      showDeptHelpList: false,
      showBranchHelpList: false,
      showFundHelpList: false,
      showPolTypeHelpList: false,
      submitting: false,
      form: {
        rptType: 'D',
        rptBy: 'L',
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        branch: 'All',
        fund: 'All',
        dept: 'All',
        polType: 'All',
        pbPrtParam: true,
        format: 'PDF'
      },
      labels: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        branch: 'Branch',
        fund: 'Fund',
        dri: 'Direct / RI',
        dept: 'Department',
        polType: 'Policy Type',
        rptType: 'Type of Report',
        rptBy: 'Report By',
        pbPrtParam: 'Print Runtime Parameters',
        export: 'EXPORT TO'
      },
      rptTypeList: [
        { label: 'Both', value: 'B' },
        { label: 'Detail', value: 'D' },
        { label: 'Summary', value: 'S' }
      ],
      rptByList: [
        { label: 'Claim Year', value: 'C' },
        { label: 'Loss Year', value: 'L' },
        { label: 'Underwriting Year', value: 'U' }
      ],
      supportedFormat: [],
      systemDate: new Date(),
      panel1: [0],
      panel2: [],
      panel3: []
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.clmPaidAndLossRes
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.showBranchHelpList = false
      this.showFundHelpList = false
      this.showPolTypeHelpList = false
      this.showDeptHelpList = false
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    },
    async doAssignPolType(obj) {
      this.form.polType = []
      this.form.polType = obj.finalSelectedItems.toString()
    },
    async doAssignDept(Obj) {
      this.form.dept = []
      this.form.dept = Obj.finalSelectedItems.toString()
    },
    async doAssignFund(Obj) {
      this.form.fund = []
      this.form.fund = Obj.finalSelectedItems.toString()
    }
  }
}
</script>
